import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  typography: {
    marginRight: theme.spacing(4),
  },
}));

export default useStyles;
